export default "__VITE_ASSET___cFl9s8b__"